import { createStyles, withStyles, type WithStyles } from "@material-ui/core";
import { CustomTable } from "features/shared/components";
import React from "react";
import arrayUtils from "shared/arrayUtils";
import type { Goal } from "shared/types";
import { useLotGoalsTable } from "../hooks/useLotGoalsTable";
import { LotGoalFilterFormState } from "../lotGoal.types";
import { filterLotGoalPredicate } from "../utils/lotGoal.utils";

type LotGoalListTableProps = {
  filterForm: LotGoalFilterFormState;
  goals: Goal[];
  isFormPanelOpen: boolean;
  onEditClick: (row: Goal) => void;
  onToggleStatus: (row: Goal, isCurrentDeleted: boolean) => void;
} & WithStyles<typeof styles>;

function LotGoalListTable({
  filterForm,
  goals,
  isFormPanelOpen,
  onEditClick,
  onToggleStatus,
}: LotGoalListTableProps) {
  const { columns } = useLotGoalsTable({
    isFormPanelOpen,
    onEditClick,
    onToggleStatus,
  });

  const filteredRows = arrayUtils.filterItems({
    items: goals,
    predicate: (item) => filterLotGoalPredicate(item, filterForm),
  });

  return (
    <CustomTable
      columns={columns}
      getRowId={(row) => row.id.toString()}
      id="lot-goals-list-table"
      rows={filteredRows}
    />
  );
}

const styles = () => createStyles({});

export default withStyles(styles)(LotGoalListTable);
